/* ==========================================================================
   GET A QUOTATION (PDF)  .  the engine                     Stage 4, 2026-09-14
   ..........................................................................
   GENERATED by _build-stage4.py from the approved draft V3.29. Do not hand
   edit, the next build overwrites it. Change the draft, re-run the builder.

   The form logic, the two branches, the surcharge, the add-ons, the cart drawer,
   the document and the PDF engine are the draft's own code, unchanged, because
   that is the code that produced the document Boss approved and redrawing it
   would mean re-measuring the geometry. What this build changes is only where
   the figures come from, and each of those edits is marked THEME below.
   ========================================================================== */

(function(){
  'use strict';

  /* THEME, zh localization 2026-09-24 (_quotation_i18n.py). ON-SCREEN LABELS
     ONLY: nothing buildPayload() posts to n8n and nothing the PDF prints reads
     these helpers (Boss: "jangan pernah edit n8n nya sama sekali termasuk apa yg
     dikirim ... pdf nya tetep apa adanya"). T() returns the English it was handed
     whenever the block or the key is missing, so English prints exactly as it
     did before this pass. */
  var I18N=(function(){try{var e=document.getElementById('qwI18n');return e?JSON.parse(e.textContent||'{}'):{};}catch(err){return {};}})();
  function T(k,en){var s=I18N[k];return (typeof s==='string'&&s)?s:en;}
  function TF(k,en,vars){var s=T(k,en);for(var n in vars){if(Object.prototype.hasOwnProperty.call(vars,n))s=s.split('{'+n+'}').join(String(vars[n]));}return s;}
  function lab(name){var e=document.querySelector('input[name="'+name+'"]:checked');if(!e)return '';var sp=e.parentNode&&e.parentNode.querySelector('span');return sp?sp.textContent.trim():e.value;}
  function xName(x){return x.title==='Dedicated Server'?T('x_server',x.title):x.title;}
  function xVar(x){return x.variant==='Per server, 3 hour service window'?T('x_server_var',x.variant):(x.variant||'');}

  /* THEME. The draft sniffed the hostname because it also had to run as a file
     opened from a Downloads folder with no store behind it. Rendered by Liquid
     there is no such case, so the storefront endpoints are always the real ones
     and the draft's demo cart is deleted rather than left dormant. */
  var LIVE = true;

  var CART = [];
  var EXTRAS = [];
  // V3.27 R5, Boss 2026-09-12: "add price and random image ... use appropriate
  // price". The Dedicated Server still has no Shopify product, so this figure is
  // a PLACEHOLDER and it is reasoned, not picked: BBQ Chef is $650 standalone
  // and BBQ Assistant is from $310, both live, and a server neither grills nor
  // cooks, it carries and serves, so it sits below the assistant. $180 covers
  // the 3 hour service window the T&C already defines for on-site staff. Jay
  // confirms the number before this reaches a real quotation.
  // Photo is Shiok's OWN footage, Design System/Real Footage/
  // chef-plating-seafood-kitchen-13.jpg, centre cropped square at 480px and
  // embedded, so there is no stock licence to argue about and no network call.
  var EXTRA_DEFS = {
    'Dedicated Server': {
      price: 25000,
      variant: 'Per server, 3 hour service window',
      image: (document.getElementById('qwDocAssets')
               || document.createElement('span')).getAttribute('data-server-photo') || '', /* THEME */
    }
  };
  function extraDef(t){ return EXTRA_DEFS[t] || {price:0, variant:'Price confirmed in quotation', image:''}; }
  function extraQty(x){ return Math.max(1, parseInt(x && x.quantity, 10) || 1); }
  function extrasSubtotal(){ return EXTRAS.reduce(function(s,x){ return s + (x.price||0)*extraQty(x); },0); }
  function extrasUnits(){ return EXTRAS.reduce(function(s,x){ return s + extraQty(x); },0); }

  // Last-Minute Booking Surcharge, per the T&C tiers Boss already approved:
  // 48 to 72 hours $50, 24 to 48 hours $80, within 24 hours $100. Computed
  // live off the branch plus the event date and start time picked (decision
  // 36), at a flat count of 1 (decision 37, deliberate demo simplification,
  // see open item 18 for the real per-staff count this needs before launch).
  var SURCHARGE_TIERS=[
    {maxHours:24, rate:10000, label:'Last-Minute Booking Surcharge (within 24 hours)'},
    {maxHours:48, rate:8000,  label:'Last-Minute Booking Surcharge (24 to 48 hours)'},
    {maxHours:72, rate:5000,  label:'Last-Minute Booking Surcharge (48 to 72 hours)'}
  ];
  function computeSurcharge(){
    // Demo mechanism (Boss 2026-09-13): triggers off the branch plus the date
    // and time picked, NOT off matching a real BBQ Chef / Assistant product
    // handle in the cart. "Per staff member" scaling is a real n8n job, once
    // the actual staff quantity is read back from the draft order.
    if(selected('quote_type')!=='With Chef / Assistant') return null;
    var d=v('#q1Date'), t=v('#q1EventStart');
    if(!d) return null;
    var dt=new Date(d+'T'+(t||'00:00')+':00');
    if(isNaN(dt.getTime())) return null;
    var hours=(dt.getTime()-Date.now())/3600000;
    if(hours<0) return null;
    var tier=SURCHARGE_TIERS.filter(function(x){return hours<=x.maxHours;})[0];
    if(!tier) return null;
    var n=1;
    return {label:tier.label, count:n, rate:tier.rate, total:tier.rate*n, max:tier.maxHours};
  }
  // Shows only the ONE tier that actually applies to the date and time picked,
  // never the full tier table (Boss 2026-09-13): "jangan show semua kondisi
  // surcharge, cukup show sesuai date time yang dipilih".
  function renderSurchargeNotice(surcharge){
    var box=$('#q1SurchargeNotice');
    if(!box) return;
    if(!surcharge){ box.hidden=true; return; }
    box.hidden=false;
    $('#q1SurchargeNoticeTitle').textContent=T('sur_title','A last-minute booking surcharge applies.');
    $('#q1SurchargeNoticeBody').textContent=TF('sur_body','Your selected date and time fall {window}, so a {rate} per staff member surcharge applies, {total} total for {count} {staff}.',{window:T('sur_win_'+surcharge.max,surcharge.label.replace('Last-Minute Booking Surcharge ','').replace(/[()]/g,'')),rate:money(surcharge.rate),total:money(surcharge.total),count:surcharge.count,staff:surcharge.count===1?T('staff_one','staff member'):T('staff_other','staff members')});
  }
  // Shows right under the Step 01 branch choice (Boss 2026-09-13: "langsung
  // directly setelah pick, include chef/assistant"), when the cart holds ONLY
  // BBQ Chef / Assistant staff lines and no food package at all. Real product
  // handles, confirmed live in the Shopify catalogue (search_products), unlike
  // the surcharge demo above which deliberately does not check the cart.
  var STAFF_ONLY_HANDLES=['/products/bbq-chef','/products/bbq-assistant'];
  function isStaffLine(x){
    var u=(x.url||'').toLowerCase();
    return STAFF_ONLY_HANDLES.some(function(h){return u.indexOf(h)>=0;});
  }
  function updateNoFoodNotice(){
    var box=$('#q1NoFoodNotice');
    if(!box) return;
    var isService=selected('quote_type')==='With Chef / Assistant';
    var staffOnly=isService && CART.length>0 && CART.every(isStaffLine);
    box.hidden=!staffOnly;
  }
  // V3.29 R10, Boss 2026-09-14: "kalau ada product bbq chef atau assist, kasih
  // warning banner kayak gitu, untuk remove that product karna kan delivery
  // aja". Note the test is NOT the mirror of the one above. That one fires on
  // a cart holding ONLY staff, because a chef with no food is incomplete but
  // not wrong. This one fires on ANY staff line, because on a delivery there
  // is nobody to send, so even one line is a contradiction. Same two real
  // handles, so a rename breaks both notices together rather than one quietly.
  function updateStaffInDeliveryNotice(){
    var box=$('#q1StaffInDeliveryNotice'), body=$('#q1StaffInDeliveryBody');
    if(!box||!body) return;
    var isDelivery=selected('quote_type')==='Food Package Only';
    var staff=isDelivery?CART.filter(isStaffLine):[];
    box.hidden=!staff.length;
    if(!staff.length) return;
    var names=staff.map(function(x){return x.title;});
    var list=names.length===1?names[0]:names.slice(0,-1).join(T('list_sep',', '))+T('list_and',' and ')+names[names.length-1];
    body.textContent=TF('staff_body','Food Package Only is a delivery without on-site staff, so {list} cannot be quoted on this path. Remove {pron} from your quotation items to continue.',{list:list,pron:names.length===1?T('pron_it','it'):T('pron_them','them')});
  }
  // Boss 2026-09-21: the empty quotation notice. TWO conditions, not one.
  // (a) A branch must already be chosen. Boss asked for this explicitly: on a
  //     page nobody has touched yet, a warning is a telling off for something
  //     the visitor has not had a chance to do. It earns its place the moment
  //     they commit to a path and the quotation is still empty.
  // (b) Empty is CART plus EXTRAS, the SAME test trySubmit refuses on, and
  //     deliberately NOT paintCart's itemCount, which adds the surcharge. The
  //     surcharge exists on branch plus date alone, so on an empty quotation
  //     itemCount can read 1, and the box would hide while the submit still
  //     refused, which is the exact contradiction this box exists to remove.
  // Cannot collide with the two notices above, both require CART.length > 0.
  function updateEmptyQuoteNotice(){
    var box=$('#q1EmptyQuoteNotice');
    if(!box) return;
    var chosen=selected('quote_type');
    box.hidden = !(chosen && !CART.length && !EXTRAS.length);
  }
  /* THEME. The draft's PROTOTYPE_CART, its PRODUCT_FALLBACKS map and
     prototypeChange() are deleted, not disabled. Every line on this page comes
     from /cart.js, and demo prices sitting in a live file are precisely the kind
     of thing that ends up printed on a customer's document. */

  function $(s,ctx){ return (ctx||document).querySelector(s); }
  function $$(s,ctx){ return [].slice.call((ctx||document).querySelectorAll(s)); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  /* V3.33, Boss 2026-10-01: show a cart line's properties (Globo product options,
     booking gate lines) exactly as the store's own drawer does in snippets/cart-form
     .liquid: skip keys starting with an underscore and blank values, link an
     /uploads/ value by its file name. DISPLAY ONLY: buildPayload() maps its own
     fields, so nothing here reaches n8n or the PDF. */
  function propsHtml(l,cls){
    var p=l&&l.properties, h='';
    if(!p||typeof p!=='object') return '';
    Object.keys(p).forEach(function(k){
      var val=p[k];
      if(k.charAt(0)==='_'||val==null||String(val).trim()==='') return;
      val=String(val);
      h+='<span class="'+cls+'"><strong>'+esc(k)+': </strong>'
        +(val.indexOf('/uploads/')>=0?'<a href="'+esc(val)+'" target="_blank" rel="noopener">'+esc(val.split('/').pop())+'</a>':esc(val))
        +'</span>';
    });
    return h;
  }
  /* V3.34, Boss 2026-10-02: Globo choices go into the quotation PDF. GLOBO ONLY
     (Boss picked this over "everything the drawer shows"): a line qualifies only
     when its properties carry Globo's own _has_gpo marker, so chef booking lines
     and every other product send and print exactly what they did before.
     gpoPayload() is what buildPayload() sends n8n (the marker plus the visible
     keys, n8n filters again); gpoLines() is what a document prints. */
  function gpoVisible(p){
    var out=[];
    if(!p||typeof p!=='object'||!Object.prototype.hasOwnProperty.call(p,'_has_gpo')) return out;
    Object.keys(p).forEach(function(k){
      var val=p[k]==null?'':String(p[k]).trim();
      if(k.charAt(0)==='_'||val==='') return;
      out.push({key:k,value:val});
    });
    return out;
  }
  function gpoPayload(l){
    var vis=gpoVisible(l&&l.properties);
    if(!vis.length) return null;
    var o={_has_gpo:String(l.properties._has_gpo)};
    vis.forEach(function(a){o[a.key]=a.value;});
    return o;
  }
  function gpoLines(list){
    return (Array.isArray(list)?list:[]).filter(function(a){return a&&a.key&&String(a.key).charAt(0)!=='_'&&String(a.value||'').trim()!=='';})
      .map(function(a){return a.key+': '+a.value;});
  }
  function money(c){ return '$' + ((c||0)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function cartSubtotal(){ return CART.reduce(function(s,l){ return s + (l.final_line_price != null ? l.final_line_price : (l.final_price||0)*(l.quantity||1)); },0); }
  function totalUnits(){ return CART.reduce(function(s,l){ return s + (l.quantity||0); },0); }
  function selected(name){ var e=$('input[name="'+name+'"]:checked'); return e?e.value:''; }
  function fmtTime(v){
    if(!v) return '';
    var p=v.split(':').map(Number), d=new Date(2000,0,1,p[0],p[1]||0);
    return d.toLocaleTimeString('en-US', {hour:'numeric',minute:'2-digit',hour12:true});
  }
  function mins(v){ if(!v)return null; var p=v.split(':').map(Number); return p[0]*60+p[1]; }
  function fromMins(n){ n=(n+1440)%1440; var d=new Date(2000,0,1,Math.floor(n/60),n%60); return d.toLocaleTimeString('en-US', {hour:'numeric',minute:'2-digit',hour12:true}); }

  /* V3.31, Boss 2026-09-30: MINIMUM ORDER NOTICE. See the head comment for the
     why. The numbers come from #qwLeadDays, keyed by product id, because
     /cart.js carries no metafields. Page only: nothing here reaches
     buildPayload(), so n8n receives the date exactly as before. The native
     min greys earlier days in most pickers, but iPhone Safari may still offer
     them, so the field's validity is what actually refuses the submit. */
  var LEAD_DAYS=(function(){try{var e=document.getElementById('qwLeadDays');return e?JSON.parse(e.textContent||'{}'):{};}catch(err){return {};}})();
  var LEAD_COPY=function(){return {title:T('lead_title','{product} needs at least {count} {unit} notice.'), body:T('lead_body','The earliest date you can choose is {date}.'), one:T('lead_day_one','day\u2019s'), other:T('lead_day_other','days\u2019'), pay:T('lead_pay','Your date is {count} days away. Please complete your payment today to have your whole lamb ready in time.')};};
  function leadFill(s,vars){for(var n in vars){if(Object.prototype.hasOwnProperty.call(vars,n))s=s.split('{'+n+'}').join(String(vars[n]));}return s;}
  function leadRule(){
    var best=null;
    CART.forEach(function(l){
      var d=parseInt(LEAD_DAYS[String(l.product_id)],10)||0;
      if(d>0 && (!best || d>best.days)) best={days:d, title:l.title};
    });
    return best;
  }
  // Today in Singapore, whatever the buyer's own clock zone, as YYYY-MM-DD.
  function sgToday(){
    try{
      var p=new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Singapore',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      if(/^\d{4}-\d{2}-\d{2}$/.test(p)) return p;
    }catch(err){}
    return new Date(Date.now()+8*3600000).toISOString().slice(0,10);
  }
  // V3.32: days on day min to min + LEAD_PAY_EXTRA - 1 get the pay today warning.
  var LEAD_PAY_EXTRA=2;
  function leadDaysBetween(a,b){var p=a.split('-').map(Number),q=b.split('-').map(Number);return Math.round((Date.UTC(q[0],q[1]-1,q[2])-Date.UTC(p[0],p[1]-1,p[2]))/86400000);}
  function addDays(iso,n){var p=iso.split('-').map(Number);return new Date(Date.UTC(p[0],p[1]-1,p[2]+n)).toISOString().slice(0,10);}
  // Named leadDate, not longDate: the PDF engine below already declares a
  // longDate, and the later declaration silently wins (measured 2026-09-30).
  function leadDate(iso){
    var p=iso.split('-').map(Number), zh=(document.documentElement.lang||'').toLowerCase().indexOf('zh')===0;
    try{ return new Date(Date.UTC(p[0],p[1]-1,p[2])).toLocaleDateString(zh?'zh-CN':'en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}); }
    catch(err){ return iso; }
  }
  function updateLeadTime(){
    var rule=leadRule(), copy=LEAD_COPY();
    var min=rule?addDays(sgToday(),rule.days):'';
    var title=rule?leadFill(copy.title,{product:rule.title,count:rule.days,unit:rule.days===1?copy.one:copy.other}):'';
    var body=rule?leadFill(copy.body,{date:leadDate(min)}):'';
    var branch=selected('quote_type');
    var active=branch==='Food Package Only'?'#q1DeliveryDate':(branch==='With Chef / Assistant'?'#q1Date':'');
    ['#q1Date','#q1DeliveryDate'].forEach(function(id){
      var el=$(id); if(!el) return;
      // Only the branch in use carries the rule, the native min included.
      // Measured on theme dev 2026-09-30: a date typed on the chef branch and
      // left there after switching to delivery still failed rangeUnderflow
      // inside its hidden section, so the form refused with nothing on screen.
      var on=!!min && id===active;
      if(on) el.min=min; else el.removeAttribute('min');
      el.setCustomValidity(on && el.value && el.value<min ? title+' '+body : '');
    });
    // V3.32: pay today warning on the branch in use, day min to min + 1.
    var activeEl=active?$(active):null, payText='';
    if(rule && activeEl && activeEl.value && activeEl.value>=min){
      var n=leadDaysBetween(sgToday(),activeEl.value);
      if(n<rule.days+LEAD_PAY_EXTRA) payText=leadFill(copy.pay,{count:n,product:rule.title});
    }
    [['#q1LeadPayNotice','#q1LeadPayNoticeBody','#q1Date'],
     ['#q1DeliveryLeadPayNotice','#q1DeliveryLeadPayNoticeBody','#q1DeliveryDate']].forEach(function(ids){
      var box=$(ids[0]); if(!box) return;
      var on=!!payText && ids[2]===active;
      box.hidden=!on;
      if(on) $(ids[1]).textContent=payText;
    });
    [['#q1LeadNotice','#q1LeadNoticeTitle','#q1LeadNoticeBody'],
     ['#q1DeliveryLeadNotice','#q1DeliveryLeadNoticeTitle','#q1DeliveryLeadNoticeBody']].forEach(function(ids){
      var box=$(ids[0]); if(!box) return;
      box.hidden=!rule;
      if(rule){ $(ids[1]).textContent=title; $(ids[2]).textContent=body; }
    });
  }

  /* V3.35, display only, see adoptCart. */
  function isExtraCrew(i){ return !!(i&&i.properties&&i.properties._sbg_topup); }
  function shownTitle(i){
    var t=i.product_title||i.title||'';
    if(!isExtraCrew(i)) return t;
    return 'Additional '+(/assistant/i.test(t)?'BBQ Assistant':'BBQ Chef');
  }
  function shownVariant(i){ return isExtraCrew(i)?'':(i.variant_title||''); }

  function adoptCart(cart){
    CART=(cart.items||[]).map(function(i){
      return {
        key:i.key, variant_id:i.variant_id||i.id, /* THEME */
        title:i.product_title||i.title, variant_title:i.variant_title||'',
        /* V3.35, Boss 2026-10-05: the booking gate's extra crew line (hidden
           property _sbg_topup) shows as "Additional BBQ Assistant" or
           "Additional BBQ Chef" with no variant line, matching the cart.
           DISPLAY ONLY: title and variant_title stay the real product names,
           so the n8n payload, the draft order and the PDF are unchanged. */
        shown_title:shownTitle(i), shown_variant:shownVariant(i),
        quantity:i.quantity, final_line_price:i.final_line_price, final_price:i.final_price,
        image:i.image, url:i.url, product_id:i.product_id,
        properties:i.properties||{} /* V3.33, display only */
      };
    });
    paintCart();
  }

  function loadCart(){
    /* THEME. The opening state is rendered by Liquid into #qwCartData so the
       first paint is exact and there is no "loading" flash, then /cart.js keeps
       it current. A failed read leaves CART as it was rather than emptying it:
       an empty basket blocks the submit, and a buyer whose items appear to have
       vanished has been told something untrue by a dropped request. */
    return fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(adoptCart)
      .catch(function(){ paintCart(); });
  }

  function seedCart(){
    var el=document.getElementById('qwCartData');
    if(!el) return;
    try{ adoptCart(JSON.parse(el.textContent||'{}')); }catch(e){ paintCart(); }
  }
  function paintCart(){
    var surcharge=computeSurcharge();
    renderSurchargeNotice(surcharge);
    updateEmptyQuoteNotice();
    updateNoFoodNotice();
    updateStaffInDeliveryNotice();
    updateLeadTime();
    var surchargeTotal=surcharge?surcharge.total:0;
    // The surcharge is an ADDED ITEM in Order Details (Boss 2026-09-13), same
    // family as an EXTRA: it folds into the product subtotal and gets its own
    // itemised row, never a separate cost-breakdown row like Delivery/GST.
    // It never appears in the cart drawer, that surface is for editable
    // products only.
    var itemCount=CART.length + EXTRAS.length + (surcharge?1:0), units=totalUnits()+extrasUnits()+(surcharge?surcharge.count:0), sub=cartSubtotal()+extrasSubtotal()+surchargeTotal;
    /* THEME. The draft invented a $25 delivery and 9 percent GST here so the
       strip had a total to show. Shopify prices this order, and on this store a
       basket over $200 ships free, so any figure worked out in the browser would
       contradict the document the buyer is about to download. Rule 3 of the spec
       is not only about the PDF: a figure the buyer READS is a figure we must
       not invent. The strip now shows what it can actually know. */
    var total=sub;
    var summary=$('#q1BasketSummary');
    if(summary) summary.innerHTML=itemCount
      ? TF('basket_sum','Quoting <b>{items} {item_word}, {units} {unit_word}</b>, {total}',{items:itemCount,item_word:itemCount===1?T('item_one','item'):T('item_other','items'),units:units,unit_word:units===1?T('unit_one','unit'):T('unit_other','units'),total:money(total)})
      : '<b>'+T('no_items','Your quotation has no items yet')+'</b>';

    var body=$('#q1BasketBody');
    if(body){
      var rows=CART.map(function(l){
        return '<div class="qw__bline"><span class="qw__bname">'+esc(l.shown_title||l.title)
          +'<span class="qw__bvar">'+esc(l.shown_variant!=null?l.shown_variant:(l.variant_title||''))+'</span>'+propsHtml(l,'qw__bprop')+'</span>'
          +'<span class="qw__bqty">x'+l.quantity+'</span>'
          +'<span class="qw__bsum">'+money(l.final_line_price != null?l.final_line_price:(l.final_price||0)*l.quantity)+'</span></div>';
      }).join('');
      rows+=EXTRAS.map(function(x){
        return '<div class="qw__bline"><span class="qw__bname">'+esc(xName(x))
          +'<span class="qw__bvar">'+esc(xVar(x))+'</span></span>'
          +'<span class="qw__bqty">x'+extraQty(x)+'</span><span class="qw__bsum">'+(x.price?money(x.price*extraQty(x)):T('tbc','TBC'))+'</span></div>';
      }).join('');
      if(surcharge) rows+='<div class="qw__bline"><span class="qw__bname">'+esc(T('sur_label_'+surcharge.max,surcharge.label))
        +'<span class="qw__bvar">'+money(surcharge.rate)+esc(T('per_staff',' per staff member'))+'</span></span>'
        +'<span class="qw__bqty">x'+surcharge.count+'</span><span class="qw__bsum">'+money(surchargeTotal)+'</span></div>';
      body.innerHTML=rows
        +'<div class="qw__beditrow"><button class="qw__bedit" type="button" data-open-cart>'+T('edit_items','Edit items')+'</button></div>'
        +'<div class="qw__bcosts">'
        +'<div class="qw__bcostrow"><span>'+T('subtotal','Product subtotal')+'</span><b>'+money(sub)+'</b></div>'
        +''
        +'</div>';
    }
    /* THEME. The draft carried its own copy of the header and painted the pill
       by its own ids. Here the header is the site wide one, so the pill is found
       through the theme's own hooks and fed the SAME subtotal this strip shows.
       Boss caught the opposite of this on his phone on 2026-09-12, a lifted
       header still showing $3,076 over a one item quotation. */
    paintHeaderPill(units, sub);
    /* THEME. The R10 gate reads the CART, so it has to be re-tested whenever the
       cart changes and not only when a checkbox is ticked. Without this the
       buyer removes the chef line the notice told them to remove and the button
       stays grey, which reads as the page ignoring them. */
    updateDeliverySubmitState();
    paintDrawer();
    paintReview();
    paintDeliveryReview();
    syncProductButtons();
  }

  function paintDrawer(){
    var dlgBody=$('#qwDialogBody'), count=$('#qwDialogCount'), sub=$('#qwDialogSub');
    if(!dlgBody) return;
    var nItems=CART.length+EXTRAS.length;
    if(count) count.textContent=TF('drawer_count','{n} {word}',{n:nItems,word:nItems===1?T('item_one','item'):T('item_other','items')});
    if(sub) sub.textContent=money(cartSubtotal()+extrasSubtotal());

    var html='';
    CART.forEach(function(l){
      html+='<div class="qd__line">'
        +(l.image?'<img class="qd__thumb" src="'+esc(l.image)+'" alt="">':'<span class="qd__thumb"></span>')
        +'<div><div class="qd__name">'+esc(l.shown_title||l.title)+'</div><span class="qd__var">'+esc(l.shown_variant!=null?l.shown_variant:(l.variant_title||''))+'</span>'+propsHtml(l,'qd__prop')+'</div>'
        +'<div class="qd__sum">'+money(l.final_line_price != null?l.final_line_price:(l.final_price||0)*l.quantity)+'</div>'
        +'<div class="qd__ctl"><span class="qd__stp">'
        +'<button class="qd__sbtn" type="button" data-cart-key="'+esc(l.key)+'" data-d="-1"'+(l.quantity<=1?' disabled':'')+'>−</button>'
        +'<span class="qd__qty">'+l.quantity+'</span>'
        +'<button class="qd__sbtn" type="button" data-cart-key="'+esc(l.key)+'" data-d="1">+</button>'
        +'</span><button class="qd__rm" type="button" data-remove-cart="'+esc(l.key)+'">'+T('remove','Remove')+'</button></div></div>';
    });
    EXTRAS.forEach(function(x){
      html+='<div class="qd__line">'
        +(x.image?'<img class="qd__thumb" src="'+x.image+'" alt="" width="480" height="480">'
                 :'<div class="qd__thumb"></div>')
        +'<div><div class="qd__name">'+esc(xName(x))+'</div><span class="qd__var">'+esc(xVar(x))+'</span></div>'
        +'<div class="qd__sum">'+(x.price?money(x.price*extraQty(x)):T('tbc','TBC'))+'</div>'
        +'<div class="qd__ctl"><span class="qd__stp">'
        +'<button class="qd__sbtn" type="button" data-extra-key="'+esc(x.title)+'" data-d="-1"'+(extraQty(x)<=1?' disabled':'')+'>\u2212</button>'
        +'<span class="qd__qty">'+extraQty(x)+'</span>'
        +'<button class="qd__sbtn" type="button" data-extra-key="'+esc(x.title)+'" data-d="1">+</button>'
        +'</span><button class="qd__rm" type="button" data-remove-extra="'+esc(x.title)+'">'+T('remove','Remove')+'</button></div></div>';
    });
    if(!html) html='<div class="qd__empty">'+T('no_items_dot','Your quotation has no items yet.')+'</div>';
    dlgBody.innerHTML=html;
  }

  function changeCart(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();}).then(adoptCart).catch(function(){});
  }
  function addProduct(handle,variantMatch,button){
    if(button){ button.disabled=true; button.textContent=T('adding','Adding…'); }
    fetch('/products/'+handle+'.js',{headers:{'Accept':'application/json'}})
      .then(function(r){ if(!r.ok) throw new Error('product'); return r.json(); })
      .then(function(p){
        var variants=(p.variants||[]).filter(function(v){return v.available!==false;});
        var v=variants[0];
        if(variantMatch){
          var wanted=variants.filter(function(x){return String(x.title||'').toLowerCase().indexOf(String(variantMatch).toLowerCase())>=0;})[0];
          if(wanted) v=wanted;
        }
        if(!v) throw new Error('variant');
        return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
      })
      .then(function(r){if(!r.ok)throw new Error('add'); return r.json();})
      .then(function(){return loadCart();})
      .then(function(){openCart(button);})
      .catch(function(){ if(button){button.disabled=false;button.textContent=T('try_again','Try Again');} });
  }

  function addExtra(title,button){
    if(!EXTRAS.some(function(x){return x.title===title;})){
      var def=extraDef(title);
      EXTRAS.push({title:title, price:def.price, variant:def.variant, image:def.image, quantity:1});
    }
    paintCart(); openCart(button);
  }

  // V3.27 R4: the ADDED label has to stay as short as the idle one. Measured at
  // 375px, "Added · View Items" runs about 130px against "Quick add" at 74 and
  // pushes the title column to three lines, which is the same squeeze that made
  // us drop the specific labels in R2. So the narrow breakpoint says "Added".
  var narrowMQ = window.matchMedia('(max-width:700px)');
  function addedLabel(){ return narrowMQ.matches ? T('added','Added') : T('added_view','Added · View Items'); }
  function syncProductButtons(){
    var lab=addedLabel();
    $$('[data-add-product]').forEach(function(b){
      var h=b.getAttribute('data-add-product');
      var added=CART.some(function(x){return (x.url||'').indexOf('/products/'+h)>=0;});
      b.classList.toggle('is-added',added);
      b.disabled=false;
      b.textContent=added?lab:(b.getAttribute('data-add-label')||T('add_to_quote','Add to Quotation'));
    });
    $$('[data-add-extra]').forEach(function(b){
      var title=b.getAttribute('data-add-extra');
      var added=EXTRAS.some(function(x){return x.title===title;});
      b.classList.toggle('is-added',added);
      b.textContent=added?lab:T('quick_add','Quick add');
    });
  }
  if(narrowMQ.addEventListener) narrowMQ.addEventListener('change',syncProductButtons);
  else if(narrowMQ.addListener) narrowMQ.addListener(syncProductButtons);

  function setRequired(ids,on){
    ids.forEach(function(id){var el=$(id);if(el)el.required=!!on;});
  }

  var mobileChoiceMQ=window.matchMedia('(max-width:700px)');

  function requireChoice(name,selectId,on){
    var radios=$$('input[name="'+name+'"]');
    radios.forEach(function(i){i.required=false;});
    var mobile=mobileChoiceMQ.matches;
    var select=$(selectId);
    if(select) select.required=mobile && !!on;
    if(!mobile && on && radios[0]) radios[0].required=true;
  }

  function syncMobileSelects(){
    $$('.q1__mobilechoice[data-radio-name]').forEach(function(select){
      var name=select.getAttribute('data-radio-name');
      var current=selected(name);
      if(current && select.value!==current) select.value=current;
    });
  }

  $$('.q1__mobilechoice[data-radio-name]').forEach(function(select){
    select.addEventListener('change',function(){
      var name=this.getAttribute('data-radio-name');
      var wanted=this.value;
      $$('input[name="'+name+'"]').forEach(function(radio){
        radio.checked=radio.value===wanted;
      });
    });
  });

  $$('input[type="radio"]').forEach(function(radio){
    radio.addEventListener('change',syncMobileSelects);
  });

  // Every quotation carries a delivery component, food or staff, so the Delivery
  // Policy checkbox is unconditional on both branches, alongside Terms.
  function updateServiceSubmitState(){
    var submit=$('#q1Submit');
    if(!submit) return;
    submit.disabled=!($('#q1PolicyAck').checked && $('#q1Terms').checked);
  }
  function updateDeliverySubmitState(){
    var submit=$('#q1DeliverySubmit');
    if(!submit) return;
    /* THEME, Boss 2026-09-14. A delivery sends nobody, so a Food Package Only
       quotation that still holds a BBQ Chef or BBQ Assistant is not a warning,
       it is a quotation that cannot be honoured. The R10 notice above names the
       offending lines and its own control opens the drawer, so the button is
       never grey without the reason sitting directly above it. The gate is a
       section setting, because Boss reversed this once inside one hour and the
       next reversal should not need a code push. */
    var blocked=false;
    if(cfgFlag('block-staff') && selected('quote_type')==='Food Package Only'){
      blocked=CART.some(isStaffLine);
    }
    submit.disabled=blocked||!($('#q1DeliveryPolicyAck').checked && $('#q1DeliveryTerms').checked);
  }
  function updateLogic(){
    updateEmptyQuoteNotice();
    updateLeadTime();
    var quoteType=selected('quote_type');
    var isService=quoteType==='With Chef / Assistant';
    var isDelivery=quoteType==='Food Package Only';

    $$('.q1__service-flow').forEach(function(sec){sec.hidden=!isService;});
    $$('.q1__delivery-flow').forEach(function(sec){sec.hidden=!isDelivery;});

    // Service-only required fields are disabled until the service path is chosen.
    setRequired(['#q1Date','#q1Pax','#q1EventStart','#q1EventEnd','#q1Meal','#q1Venue','#q1Postal','#q1Name','#q1Phone','#q1Email'],isService);
    requireChoice('venue_type','#q1VenueTypeMobile',isService);
    requireChoice('has_grill','#q1HasGrillMobile',isService);
    requireChoice('shelter','#q1ShelterMobile',isService);
    requireChoice('dining','#q1DiningMobile',isService);

    // Delivery-only path is intentionally short per the latest direction.
    setRequired(['#q1DeliveryDate','#q1DeliverySlot','#q1DeliveryAddress','#q1DeliveryPostal','#q1DeliveryName','#q1DeliveryPhone','#q1DeliveryEmail'],isDelivery);

    var venueType=selected('venue_type');
    $('#q1VenueOtherWrap').hidden=!isService || venueType!=='Other';
    $('#q1VenueOther').required=isService && venueType==='Other';

    var grill=selected('has_grill');
    $('#q1GrillTypeWrap').hidden=!isService || grill!=='Yes';
    $('#q1GrillUnsure').hidden=!isService || grill!=='Not sure';
    $('#q1GrillRentalWrap').hidden=!isService || grill!=='No';
    requireChoice('grill_type','#q1GrillTypeMobile',isService && grill==='Yes');

    var shelter=selected('shelter');
    $('#q1WetWeather').hidden=!isService || !(shelter==='Partially'||shelter==='No');

    var dining=selected('dining');
    $('#q1ServerWrap').hidden=!isService || dining!=='Separate dining / function room';

    var corp=isService && $('#q1Corporate').checked;
    $('#q1CompanyWrap').hidden=!corp;
    ['#q1Company','#q1CompanyAddress'].forEach(function(id){$(id).required=corp;});

    var deliveryCorp=isDelivery && $('#q1DeliveryCorporate').checked;
    $('#q1DeliveryCompanyWrap').hidden=!deliveryCorp;
    ['#q1DeliveryCompany','#q1DeliveryCompanyAddress'].forEach(function(id){$(id).required=deliveryCorp;});

    if(!isService){
      $('#q1Terms').checked=false;
      $('#q1PolicyAck').checked=false;
      $('#q1Submit').disabled=true;
    }
    if(!isDelivery){
      $('#q1DeliveryTerms').checked=false;
      $('#q1DeliveryPolicyAck').checked=false;
      $('#q1DeliverySubmit').disabled=true;
    }

    syncMobileSelects();
    updateTiming();
    paintReview();
    paintDeliveryReview();
  }

  function updateTiming(){
    var meal=$('#q1Meal').value, box=$('#q1Timing');
    if(!meal){box.hidden=true;return;}
    var m=mins(meal);
    $('#q1Arrival').textContent=fromMins(m-120)+' – '+fromMins(m-60);
    $('#q1MealDisplay').textContent=fmtTime(meal);
    box.hidden=false;
  }

  function v(id){var e=$(id);return e?e.value.trim():'';}
  function selectedText(id){var e=$(id);if(!e||!e.value)return '';var o=e.options&&e.options[e.selectedIndex];return o?o.textContent.trim():'';}
  function row(k,vv){return '<div class="q1__reviewrow"><span>'+esc(k)+'</span><strong>'+(vv?esc(vv):'—')+'</strong></div>';}
  function group(title,rows){return '<div class="q1__reviewgroup"><div class="q1__reviewhead">'+esc(title)+'</div><div class="q1__reviewbody">'+rows+'</div></div>';}
  function valueOnly(vv){return '<div class="q1__reviewvalue"><strong>'+(vv?esc(vv):'—')+'</strong></div>';}

  function orderDetailsReview(){
    var surcharge=computeSurcharge();
    var surchargeTotal=surcharge?surcharge.total:0;
    var sub=cartSubtotal()+extrasSubtotal()+surchargeTotal;
    /* THEME, same reason as the basket strip above. */
    var total=sub;
    var html='<div class="q1__orderdetails">';
    if(CART.length || EXTRAS.length || surcharge){
      CART.forEach(function(l){
        var linePrice=l.final_line_price != null?l.final_line_price:(l.final_price||0)*l.quantity;
        html+='<div class="q1__orderline">'
          +'<div class="q1__ordername">'+esc(l.shown_title||l.title)
          +((l.shown_variant!=null?l.shown_variant:l.variant_title)?'<span class="q1__ordervar">'+esc(l.shown_variant!=null?l.shown_variant:l.variant_title)+'</span>':'')
          +'</div><span class="q1__orderqty">x'+l.quantity+'</span>'
          +'<span class="q1__orderprice">'+money(linePrice)+'</span></div>';
      });
      EXTRAS.forEach(function(x){
        html+='<div class="q1__orderline">'
          +'<div class="q1__ordername">'+esc(xName(x))+'<span class="q1__ordervar">'+esc(xVar(x))+'</span></div>'
          +'<span class="q1__orderqty">x'+extraQty(x)+'</span><span class="q1__orderprice">'+(x.price?money(x.price*extraQty(x)):T('tbc','TBC'))+'</span></div>';
      });
      if(surcharge) html+='<div class="q1__orderline">'
        +'<div class="q1__ordername">'+esc(T('sur_label_'+surcharge.max,surcharge.label))+'<span class="q1__ordervar">'+money(surcharge.rate)+esc(T('per_staff',' per staff member'))+'</span></div>'
        +'<span class="q1__orderqty">x'+surcharge.count+'</span><span class="q1__orderprice">'+money(surchargeTotal)+'</span></div>';
    }else{
      html+='<div class="q1__orderline"><div class="q1__ordername">'+T('no_items_short','No items yet')+'</div></div>';
    }
    html+='<div class="q1__orderedit"><button type="button" data-open-cart>'+T('edit_items','Edit items')+'</button></div>'
      +'<div class="q1__ordercosts">'
      +'<div class="q1__ordercostrow"><span>'+T('subtotal','Product subtotal')+'</span><b>'+money(sub)+'</b></div>'
      +'<div class="q1__ordercostnote">'+T('cost_note','Delivery and 9% GST are calculated by our booking system and shown on your quotation.')+'</div>'
      +'</div></div>';
    return html;
  }

  function paintReview(){
    var box=$('#q1Review'); if(!box)return;
    var venueType=selected('venue_type');
    if(venueType==='Other') venueType=v('#q1VenueOther'); else if(venueType) venueType=lab('venue_type');
    var grill=selected('has_grill'), grillType=selected('grill_type');
    var dining=selected('dining');

    box.innerHTML=
      group(T('rv_service','Service type'),valueOnly(T('val_with_staff','With Chef / Assistant')))+
      group(T('rv_event','Event'),
        row(T('rv_date','Date'),v('#q1Date'))+
        row(T('rv_event_time','Event time'),(v('#q1EventStart')?fmtTime(v('#q1EventStart')):'')+(v('#q1EventEnd')?' - '+fmtTime(v('#q1EventEnd')):''))+
        row(T('rv_meal','Meal time'),v('#q1Meal')?fmtTime(v('#q1Meal')):'')+
        row(T('rv_guests','Guests'),v('#q1Pax'))+
        row(T('rv_venue_type','Venue type'),venueType)+
        row(T('rv_venue','Venue'),v('#q1Venue'))+
        row(T('rv_postal','Postal code'),v('#q1Postal'))
      )+
      group(T('rv_setup','Setup'),
        row(T('rv_grill','Grill'),lab('has_grill')+(grill==='Yes'&&grillType?' · '+lab('grill_type'):''))+
        row(T('rv_shelter','Sheltered area'),lab('shelter'))+
        row(T('rv_dining','Dining'),lab('dining'))
      )+
      group(T('rv_contact','Contact'),
        row(T('rv_name','Name'),v('#q1Name'))+
        row(T('rv_phone','Phone / WhatsApp'),v('#q1Phone'))+
        row(T('rv_email','Email'),v('#q1Email'))+
        (v('#q1Notes')?row(T('rv_notes','Additional notes'),v('#q1Notes')):'')+
        ($('#q1Corporate').checked
          ? row(T('rv_company','Company'),v('#q1Company'))+row(T('rv_company_address','Company address'),v('#q1CompanyAddress'))
          : '')
      )+
      group(T('rv_order','Order details'),orderDetailsReview());
  }

  function paintDeliveryReview(){
    var box=$('#q1DeliveryReview'); if(!box)return;
    box.innerHTML=
      group(T('rv_service','Service type'),valueOnly(T('val_food_only','Food Package Only')))+
      group(T('rv_delivery','Delivery'),
        row(T('rv_delivery_date','Delivery date'),v('#q1DeliveryDate'))+
        row(T('rv_delivery_slot','Delivery time slot'),selectedText('#q1DeliverySlot'))+
        row(T('rv_delivery_address','Delivery address'),v('#q1DeliveryAddress'))+
        row(T('rv_postal','Postal code'),v('#q1DeliveryPostal'))
      )+
      group(T('rv_contact','Contact'),
        row(T('rv_name','Name'),v('#q1DeliveryName'))+
        row(T('rv_phone','Phone / WhatsApp'),v('#q1DeliveryPhone'))+
        row(T('rv_email','Email'),v('#q1DeliveryEmail'))+
        (v('#q1DeliveryNotes')?row(T('rv_notes','Additional notes'),v('#q1DeliveryNotes')):'')+
        ($('#q1DeliveryCorporate').checked
          ? row(T('rv_company','Company'),v('#q1DeliveryCompany'))+row(T('rv_company_address','Company address'),v('#q1DeliveryCompanyAddress'))
          : '')
      )+
      group(T('rv_order','Order details'),orderDetailsReview());
  }

  // Basket strip
  var basket=$('#qwBasket'), basketBtn=$('#qwBasketBtn');
  if(basketBtn) basketBtn.addEventListener('click',function(){
    var on=basket.classList.toggle('is-open');
    basketBtn.setAttribute('aria-expanded',on?'true':'false');
    var label=basketBtn.querySelector('.qw__baskettogglelabel');
    if(label) label.textContent=on?T('hide','Hide'):T('view','View');
  });

  // Drawer
  var dlg=$('#qwDialog'), opener=null;
  function openCart(from){
    if(!dlg)return;
    opener=from||null; paintDrawer(); dlg.hidden=false; dlg.classList.add('is-on');
    document.body.classList.add('qd-lock');
    requestAnimationFrame(function(){requestAnimationFrame(function(){dlg.classList.add('is-in');});});
  }
  function closeCart(){
    if(!dlg)return;
    dlg.classList.remove('is-in'); document.body.classList.remove('qd-lock');
    setTimeout(function(){dlg.classList.remove('is-on');dlg.hidden=true;if(opener&&opener.focus)opener.focus();opener=null;},300);
  }
  document.addEventListener('click',function(e){
    var open=e.target.closest&&e.target.closest('[data-open-cart]');
    if(open){ if(open.tagName==='A') e.preventDefault(); openCart(open); return; }
    var close=e.target.closest&&e.target.closest('[data-close-cart]');
    if(close){closeCart();return;}
    var add=e.target.closest&&e.target.closest('[data-add-product]');
    if(add){
      var handle=add.getAttribute('data-add-product');
      var already=CART.some(function(x){return (x.url||'').indexOf('/products/'+handle)>=0;});
      if(already){openCart(add);return;}
      addProduct(handle,add.getAttribute('data-variant-match'),add);return;
    }
    var extra=e.target.closest&&e.target.closest('[data-add-extra]');
    if(extra){
      var title=extra.getAttribute('data-add-extra');
      if(EXTRAS.some(function(x){return x.title===title;})){openCart(extra);return;}
      addExtra(title,extra);return;
    }
    var step=e.target.closest&&e.target.closest('[data-cart-key]');
    if(step){
      var key=step.getAttribute('data-cart-key'), delta=+step.getAttribute('data-d');
      var line=CART.filter(function(x){return x.key===key;})[0];
      if(line){var q=line.quantity+delta;if(q>=1)changeCart(key,q);}
      return;
    }
    var rm=e.target.closest&&e.target.closest('[data-remove-cart]');
    if(rm){changeCart(rm.getAttribute('data-remove-cart'),0);return;}
    var estep=e.target.closest&&e.target.closest('[data-extra-key]');
    if(estep){
      var et=estep.getAttribute('data-extra-key'), ed=+estep.getAttribute('data-d');
      EXTRAS.forEach(function(x){ if(x.title===et){ x.quantity=Math.max(1, extraQty(x)+ed); } });
      paintCart(); return;
    }
    var rmx=e.target.closest&&e.target.closest('[data-remove-extra]');
    if(rmx){EXTRAS=EXTRAS.filter(function(x){return x.title!==rmx.getAttribute('data-remove-extra');});paintCart();return;}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&dlg&&!dlg.hidden)closeCart();});

  // Terms modal
  var tmodal=$('#q1TermsModal');
  function openTerms(){tmodal.classList.add('is-on');tmodal.setAttribute('aria-hidden','false');}
  function closeTerms(){tmodal.classList.remove('is-on');tmodal.setAttribute('aria-hidden','true');}
  var dmodal=$('#q1DeliveryPolicyModal');
  function openDelivery(){dmodal.classList.add('is-on');dmodal.setAttribute('aria-hidden','false');}
  function closeDelivery(){dmodal.classList.remove('is-on');dmodal.setAttribute('aria-hidden','true');}
  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('[data-open-terms]')){e.preventDefault();openTerms();}
    if(e.target.closest&&e.target.closest('[data-close-terms]'))closeTerms();
    if(e.target.closest&&e.target.closest('[data-open-delivery]')){e.preventDefault();openDelivery();}
    if(e.target.closest&&e.target.closest('[data-close-delivery]'))closeDelivery();
  });

  // Date fields: clicking anywhere opens the native calendar; manual date entry is blocked.
  document.querySelectorAll('.qw__input[type="date"]').forEach(function(dateInput){
    dateInput.setAttribute('inputmode','none');
    dateInput.addEventListener('click',function(){
      if(typeof this.showPicker==='function'){ try{ this.showPicker(); }catch(err){} }
    });
    dateInput.addEventListener('keydown',function(e){
      if(e.key==='Tab' || e.key==='Shift' || e.key==='Escape')return;
      if(e.key==='Enter' && typeof this.showPicker==='function'){
        e.preventDefault(); try{ this.showPicker(); }catch(err){} return;
      }
      e.preventDefault();
    });
    dateInput.addEventListener('paste',function(e){e.preventDefault();});
    dateInput.addEventListener('drop',function(e){e.preventDefault();});
  });

  // Form logic
  if(mobileChoiceMQ.addEventListener) mobileChoiceMQ.addEventListener('change',updateLogic);
  else if(mobileChoiceMQ.addListener) mobileChoiceMQ.addListener(updateLogic);
  $('#q1Form').addEventListener('change',updateLogic);
  $('#q1Form').addEventListener('input',function(){updateTiming();paintCart();});
  $('#q1Terms').addEventListener('change',updateServiceSubmitState);
  $('#q1PolicyAck').addEventListener('change',updateServiceSubmitState);
  $('#q1DeliveryTerms').addEventListener('change',updateDeliverySubmitState);
  $('#q1DeliveryPolicyAck').addEventListener('change',updateDeliverySubmitState);

  /* V3.27 R7: both submits now do the same thing, hand off to submitQuote(),
     which swaps the page for the thank you state and builds the real document.
     The two guards stay because the page renders BOTH branches' submit buttons
     and only the active branch may fire. An EMPTY quotation is refused here as
     well, because there is nothing to put on a document. */
  function trySubmit(branch, termsSel, isService, button){
    if (selected('quote_type') !== branch) return;
    // Boss 2026-09-21: an empty quotation used to open the cart drawer, whose
    // only content is "no items yet" and a Done button, so the buyer hit a dead
    // end after filling the whole form. Send them to the notice instead, which
    // has somewhere to go. openCart stays as the floor if the box is missing.
    if (!CART.length && !EXTRAS.length) {
      var emptyBox = $('#q1EmptyQuoteNotice');
      if (emptyBox && !emptyBox.hidden) {
        emptyBox.setAttribute('tabindex', '-1');
        emptyBox.scrollIntoView({ block: 'center' });
        emptyBox.focus();
      } else { openCart(); }
      return;
    }
    if (!$('#q1Form').checkValidity()) { $('#q1Form').reportValidity(); return; }
    if (!$(termsSel).checked) return;
    submitQuote(isService, button);
  }
  $('#q1Submit').addEventListener('click', function(){
    trySubmit('With Chef / Assistant', '#q1Terms', true, this);
  });
  $('#q1DeliverySubmit').addEventListener('click', function(){
    trySubmit('Food Package Only', '#q1DeliveryTerms', false, this);
  });


  /* ====================================================================
     ADAPTER, V3.27 R7
     ....................................................................
     The quotation document machinery below is a VERBATIM port from the
     wizard draft in Old Versions/, because that code is what produced the
     PDF Boss approved and redrawing it would mean re-measuring the
     geometry. It was written against the wizard's own field ids, its
     CART_LINES array and its delivery slot. This layer, and only this
     layer, is what makes it read the one page form instead.

     THE FORM HAS TWO BRANCHES, so val() cannot be a plain id lookup: the
     same document field comes from q1Name on the chef branch and from
     q1DeliveryName on the delivery branch. One map, read at call time, so
     a buyer who switches branch after typing cannot leak the other
     branch's answers onto the document.
     ==================================================================== */
  var Q_FIELDS = {
    service: { qwDate:'q1Date', qwGuests:'q1Pax', qwVenue:'q1Venue', qwPostal:'q1Postal',
               qwName:'q1Name', qwPhone:'q1Phone', qwEmail:'q1Email',
               qwCo:'q1Company', qwCoAddr:'q1CompanyAddress', qwUen:'q1Uen',
               qwMsg:'q1Notes' },
    delivery:{ qwDate:'q1DeliveryDate', qwGuests:'', qwVenue:'q1DeliveryAddress',
               qwPostal:'q1DeliveryPostal', qwName:'q1DeliveryName',
               qwPhone:'q1DeliveryPhone', qwEmail:'q1DeliveryEmail',
               qwCo:'q1DeliveryCompany', qwCoAddr:'q1DeliveryCompanyAddress',
               qwUen:'q1DeliveryUen', qwMsg:'q1DeliveryNotes' }
  };
  function isServiceQuote(){ return selected('quote_type') === 'With Chef / Assistant'; }
  function val(k){
    var map = isServiceQuote() ? Q_FIELDS.service : Q_FIELDS.delivery;
    var id = Object.prototype.hasOwnProperty.call(map, k) ? map[k] : k;
    if (!id) return '';
    /* The company fields only count when the box is ticked, otherwise a buyer
       who typed a company name and then unticked would still see it printed. */
    if (k === 'qwCo' || k === 'qwCoAddr' || k === 'qwUen') {
      var box = $(isServiceQuote() ? '#q1Corporate' : '#q1DeliveryCorporate');
      if (box && !box.checked) return '';
    }
    var e = document.getElementById(id);
    return e ? String(e.value || '').trim() : '';
  }

  /* The document's EVENT DETAILS line. The two branches answer different
     questions, so they get different sentences rather than one that is wrong on
     one of them: the delivery branch has a real GAF slot and prints it as a
     delivery window, the chef branch has a meal time and prints when the food
     is served. */
  function slotLabel(){
    if (isServiceQuote()) {
      var m = $('#q1Meal');
      return (m && m.value) ? 'Food served from ' + fmtTime(m.value) : '';
    }
    var s = $('#q1DeliverySlot');
    if (!s || !s.value) return '';
    var o = s.options[s.selectedIndex];
    return o ? 'Delivery ' + o.textContent.trim() : '';
  }

  function subtotal(){ return cartSubtotal() + extrasSubtotal(); }

  /* One row per quoted line, products first then quote only services, in the
     shape fillDoc() already expects. unit is a per unit figure because the
     document prints unit price and quantity as separate columns, so it is
     derived from the line total when Shopify only gave us that. */
  function quoteLines(){
    var out = CART.map(function (l) {
      var qty = l.quantity || 1;
      var unit = (l.final_price != null)
        ? l.final_price
        : Math.round((l.final_line_price || 0) / qty);
      return { title: l.title, variant: l.variant_title || '', sku: '', qty: qty, unit: unit,
               props: gpoLines(gpoVisible(l.properties)) };
    });
    EXTRAS.forEach(function (x) {
      out.push({ title: x.title, variant: x.variant || '', sku: '', qty: 1, unit: x.price || 0 });
    });
    return out;
  }

  /* THE FACE COMES OUT OF THIS PAGE'S OWN CSSOM, not a second copy of the
     woff2. The theme version hands the iframe a Liquid asset_url; a standalone
     file has no such url, and embedding Inter Tight twice would add about 60KB
     for nothing. So read the font face this page already carries and write its
     own src into the iframe. If the rule cannot be found, fall back to the
     configured url, and if that is empty too the sheet still prints in the
     system stack rather than not printing at all. */
  function fontFace(){
    var src = '';
    try {
      for (var i = 0; i < document.styleSheets.length; i++) {
        var rules;
        try { rules = document.styleSheets[i].cssRules; } catch (e) { continue; }
        if (!rules) continue;
        for (var j = 0; j < rules.length; j++) {
          var r = rules[j];
          if (r.type === 5 && /Inter Tight/i.test(r.style.getPropertyValue('font-family'))) {
            src = r.style.getPropertyValue('src');
            break;
          }
        }
        if (src) break;
      }
    } catch (e) {}
    if (!src) {
      var u = cfg('font', '');
      if (!u) return '';
      src = 'url(' + JSON.stringify(absUrl(u)) + ') format("woff2")';
    }
    return '<style>@font-face{font-family:"Inter Tight";src:' + src
         + ';font-weight:100 900;font-style:normal;font-display:block}</style>';
  }

  /* DRAFT ONLY. /cart/shipping_rates.json is a storefront endpoint, so opening
     this file from a folder or a share link returns nothing. Printing
     "Quoted on confirmation" there would make the PDF disagree with the review
     step on screen, which already shows the prototype 25 dollars. So the draft
     falls back to that same figure, under a name that says it is a draft
     figure. On the theme the fetch succeeds and this never runs. */


  /* ====================================================================
     THE QUOTATION DOCUMENT
     ....................................................................
     Everything below builds the A4 PDF the buyer downloads. It runs only
     where snippets/quotation-doc.liquid has rendered a #qdocSheet, so the
     standalone draft simply has no download and hides the button.

     WHY THE BROWSER'S PRINT ENGINE, not a canvas library. The document's
     stylesheet uses clip-path for the footer notch and columns:3 for the
     terms. html2canvas supports neither, so the notch would paint as a
     white rectangle across the band and the five terms would collapse
     into one column and overflow the page. Chromium's print pipeline is
     the same engine the approved PDF was measured in, costs no library,
     no CDN and no font race, and yields VECTOR text, so the buyer's
     finance team can select and copy the UEN and the figures. A raster
     canvas cannot offer that at any resolution.

     TEMPORARY, Boss 2026-09-09. The figures here are worked out in the
     browser. When n8n is up, the draft order is created first and every
     customer facing figure is read back from Shopify, per rule 3 of the
     spec. What survives that change is this file's layout work; what goes
     away is the arithmetic.
     ==================================================================== */
  /* LOOKED UP ON DEMAND, not captured at start up. The section renders the
     sheet above this script and loads the script with defer, so a captured
     reference works today. It would also break silently, and look exactly like
     "the download button does nothing", the day the snippet moved below the
     script tag. Two getElementById calls per download is not a cost worth an
     ordering assumption. */
  function qdoc() { return document.getElementById('qdocSheet'); }
  function qcfg() { return document.getElementById('qwDocAssets'); }
  var GST_RATE = 0.09;

  function cfg(k, dflt) {
    var c = qcfg();
    var v = c && c.getAttribute('data-' + k);
    return (v === null || v === undefined || v === '') ? dflt : v;
  }

  /* ABSOLUTE, ALWAYS. Liquid's asset_url returns a PROTOCOL RELATIVE url,
     "//shiokbbq.com.sg/cdn/shop/t/23/assets/...", which resolves fine in this
     page and NOT AT ALL inside the print iframe: that document is about:blank,
     which has no protocol to inherit, so the stylesheet and the font would both
     fail to load and the sheet would print in a fallback face at the wrong
     widths. Resolving against this page's own URL fixes it once, here, for
     every asset the iframe needs. */
  function absUrl(u) {
    if (!u) return '';
    try { return new URL(u, window.location.href).href; } catch (e) { return u; }
  }

  /* Shopify serves money in cents. Rounding happens ONCE, here, at the
     last moment, so no figure on the document is a rounded figure that
     was then used in another sum. */
  function cents(n) { return Math.round(n); }

  function dayName(iso) {
    var D = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    return D[new Date(iso + 'T00:00:00').getDay()];
  }
  function longDate(iso) {
    if (!iso) return '';
    var d = new Date(iso + 'T00:00:00'),
        W = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
        M = ['January','February','March','April','May','June','July',
             'August','September','October','November','December'];
    return W[d.getDay()] + ', ' + d.getDate() + ' ' + M[d.getMonth()] + ' ' + d.getFullYear();
  }
  function usDate(d) {
    var M = ['January','February','March','April','May','June','July',
             'August','September','October','November','December'];
    return M[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  /* ---- what the document says ----
     THEME, and this is the heart of the change. The draft built this object out
     of the form and its own arithmetic. It is now built out of the reply n8n
     sends, which n8n read back off the draft order Shopify priced. The browser
     performs no arithmetic on any customer facing figure: it converts Shopify's
     decimal strings to the cents the document already speaks, and prints them.

     One object, two entrances. A fresh submission and a resume link hand it the
     identical payload shape (decision 49), so fillDoc() never learns which one
     it was fed by. */
  var QUOTE = null;

  function fromAmount(s){
    /* "330.00" to 33000. Shopify sends decimal strings, the document prints
       cents. Math.round is the only arithmetic in this file that touches money
       and it is a unit conversion, not a calculation. */
    var n = parseFloat(s);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function isoToUs(iso){
    if(!iso) return '';
    var d = new Date(iso + 'T00:00:00');
    return isNaN(d.getTime()) ? iso : usDate(d);
  }

  function clockText(v){
    /* FORMAT ONCE, NEVER TWICE. n8n stores the times on the draft order already
       written for a human, "7:00 PM", so running them back through fmtTime()
       parses the hour as 7 and the minutes as NaN and prints 7:00 AM. That
       shipped and Boss caught it on a real quotation. So: if it already carries
       AM or PM it is finished, and only a bare 24 hour "19:00" is converted. */
    if (!v) return '';
    return /[ap]\.?m\.?/i.test(v) ? String(v).trim() : fmtTime(v);
  }

  function quoteTimeLine(p){
    /* The two branches answer different questions and the payload proves which
       one this is. Measured on the live endpoint: a delivery quotation returns
       event.start EMPTY and event.deliverySlot filled, a chef quotation the
       other way round. Reading the wrong one prints an empty line on half the
       quotations. */
    var e = p.event || {};
    if ((p.quoteType || '') === 'Food Package Only') {
      return e.deliverySlot ? 'Delivery ' + e.deliverySlot : '';
    }
    return e.mealTime ? 'Food served from ' + clockText(e.mealTime) : '';
  }

  function buildQuote(p){
    var e = p.event || {}, c = p.contact || {}, co = p.company || {},
        t = p.totals || {}, ship = p.shippingLine || null;
    return {
      number:   String(p.quotationNumber || '').replace(/^#/, ''),
      issue:    isoToUs(p.issueDate),
      valid:    isoToUs(p.validUntil),
      pay:      p.invoiceUrl || '',
      resume:   p.resumeUrl || '',
      date:     e.date || '',
      slot:     quoteTimeLine(p),
      guests:   e.guests ? String(e.guests) : '',
      venue:    e.venue || '',
      postal:   e.postalCode || '',
      name:     c.name || '',
      phone:    c.phone || '',
      email:    c.email || '',
      co:       co.name || '',
      coaddr:   co.address || '',
      uen:      co.uen || '',
      note:     p.message || '',
      lines:    (p.lines || []).map(function (l) {
                  return { title: l.title || '', variant: l.variantTitle || '',
                           sku: l.sku || '', qty: l.quantity || 1,
                           unit: fromAmount(l.unitPrice),
                           total: fromAmount(l.lineTotal),
                           /* V3.34: Globo choices read back off the draft order line */
                           props: gpoLines(l.properties) };
                }),
      delivery: ship ? { name: ship.title || 'Local Delivery',
                         cents: fromAmount(ship.price) } : null,
      sub:      fromAmount(t.subtotal),
      gst:      fromAmount(t.tax),
      total:    fromAmount(t.total)
    };
  }

  function setHook(key, text, hideWhenEmpty) {
    var els = qdoc().querySelectorAll('[data-q="' + key + '"]');
    for (var n = 0; n < els.length; n++) {
      els[n].textContent = text || '';
      if (hideWhenEmpty) els[n].hidden = !text;
    }
  }

  function fillDoc(q) {
    setHook('number', '#' + q.number);
    setHook('issue',  q.issue);
    setHook('valid',  q.valid);
    setHook('name',   q.name);
    /* COMPANY ROWS COLLAPSE rather than printing "not provided" three times.
       Boss's decision 6: the company step is optional and a private buyer
       should not meet a document that reads like a form they failed. */
    setHook('co',     q.co, true);
    setHook('coaddr', q.coaddr, true);
    setHook('uen',    q.uen ? 'UEN: ' + q.uen : '', true);
    setHook('phone',  q.phone ? 'Phone: ' + q.phone : '');
    setHook('email',  q.email);
    setHook('date',   longDate(q.date));
    setHook('time',   q.slot || '');
    setHook('guests', q.guests ? 'Guests: ' + q.guests : '');
    setHook('venue',  q.venue);
    setHook('postal', q.postal ? 'Singapore ' + q.postal : '');
    setHook('note',   q.note);
    var nw = qdoc().querySelector('[data-q="notewrap"]');
    if (nw) nw.hidden = !q.note;
    setHook('sub',    money(q.sub));
    setHook('gst',    money(q.gst));
    setHook('tot',    money(q.total));
    setHook('tot2',   money(q.total));

    /* THEME. The pay button and the QR both point at THIS quotation's own
       checkout, the invoiceUrl Shopify issued for the draft order, rather than
       at the shop's cart. Boss 2026-09-14, and the shape was verified against
       #D108: Shopify returns it on the store's own domain, not on myshopify. */
    var payBtn = qdoc().querySelector('[data-q="pay"]');
    if (payBtn && q.pay) payBtn.setAttribute('href', q.pay);
    paintQr(q.pay);

    /* The table. Built with createElement and textContent rather than an HTML
       string, so nothing a buyer typed is ever parsed as markup. */
    var tb = qdoc().querySelector('[data-q="rows"]');
    tb.textContent = '';
    function row(cellDefs) {
      var tr = document.createElement('tr');
      cellDefs.forEach(function (c) {
        var td = document.createElement('td');
        td.className = c[0];
        /* V3.34: c[2] may be an ARRAY of extra lines (Globo choices under the
           variant). A plain string behaves exactly as before. */
        var more = Array.isArray(c[2]) ? c[2] : (c[2] ? [c[2]] : []);
        if (more.length) {
          /* Two lines in one cell: the variant, then the SKU or the date. */
          td.appendChild(document.createTextNode(c[1]));
          more.forEach(function (x) {
            td.appendChild(document.createElement('br'));
            td.appendChild(document.createTextNode(x));
          });
        } else {
          td.textContent = c[1];
        }
        tr.appendChild(td);
      });
      tb.appendChild(tr);
    }
    q.lines.forEach(function (l) {
      var de = l.variant || '';
      if (l.sku) de = de ? de + ' - SKU: ' + l.sku : 'SKU: ' + l.sku;
      /* THEME. The line total is Shopify's own figure now, not unit times
         quantity worked out here. They agree today and they must never be given
         the chance to disagree, which is decision 49 applied one level below the
         totals. The multiply survives only as a fallback. */
      /* V3.34: Globo choices, one per line, under the variant. */
      var gp = l.props || [];
      var deCell = gp.length ? (de ? ['de', de, gp] : ['de', gp[0], gp.slice(1)]) : ['de', de];
      row([['it', l.title], deCell, ['c qty', String(l.qty)],
           ['n up', (l.unit / 100).toFixed(2)], ['c tx', '9%'],
           ['n tt', money(l.total != null ? l.total : l.unit * l.qty)]]);
    });
    row([['it', 'Local Delivery'],
         ['de', q.delivery ? q.delivery.name : 'Quoted on confirmation',
                q.date ? 'Delivery Date: ' + q.date + ' (' + dayName(q.date) + ')'
                       + (q.slot ? ', ' + q.slot : '') : ''],
         ['c qty', ''], ['n up', ''], ['c tx', ''],
         ['n tt', q.delivery ? money(q.delivery.cents) : '']]);
  }

  /* ---- turning it into a file ----
     THE SHEET IS BUILT IN AN OFF SCREEN IFRAME, always. It holds only the
     document plus assets/quotation-doc.css, so nothing of the storefront comes
     with it and, just as important, that stylesheet never touches the
     storefront: it styles bare html and body, because inside this iframe it
     owns the whole document.

     The iframe then feeds EITHER path. buildSheet() returns it, downloadDoc()
     rasterises it into a real file, and printDoc() hands it to the browser's
     print engine as the fallback. */
  /* ---- the QR ----
     A static image cannot carry a link that differs per quotation, so the code
     is drawn per document from the same invoiceUrl the button uses. The drawing
     is done by the QR library SHOPIFY ITSELF serves, the one this theme already
     loads on its gift card page, so nothing third party is added to the store.

     Its one caveat, stated rather than hidden: vendor/qrcode.js is not in the
     documented list for the shopify_asset_url filter, so it works today without
     being promised. If it ever stops resolving, the QR block hides itself and
     the pay button carries on alone. A QR still pointing at the shop cart while
     the button points at the quotation would be worse than no QR at all. */
  function paintQr(url){
    var img  = qdoc().querySelector('[data-q="qr"]');
    var wrap = qdoc().querySelector('[data-q="qrwrap"]');
    if (!img) return;
    function give_up(){ if (wrap) wrap.hidden = true; else img.hidden = true; }
    if (!url || typeof window.QRCode !== 'function') { give_up(); return; }
    try {
      var box = document.createElement('div');
      box.style.cssText = 'position:fixed;left:-10000px;top:0';
      document.body.appendChild(box);
      new window.QRCode(box, { text: url, width: 492, height: 492 });
      var made = box.querySelector('canvas') || box.querySelector('img');
      var data = made && (made.tagName === 'CANVAS' ? made.toDataURL('image/png') : made.src);
      box.remove();
      if (!data) { give_up(); return; }
      img.setAttribute('src', data);
      if (wrap) wrap.hidden = false;
    } catch (e) { give_up(); }
  }

  function buildSheet(q) {
    var f = document.createElement('iframe');
    f.setAttribute('aria-hidden', 'true');
    f.setAttribute('tabindex', '-1');
    /* Height is generous, not exactly 297mm: a long order (decision 27) now
       grows the sheet past one A4 page, and the iframe box has to be tall
       enough to lay every row out before html2canvas walks the DOM, or rows
       past 297mm would never exist to capture. Off screen, so the cost of
       overshooting is nothing. */
    f.style.cssText = 'position:fixed;left:-10000px;top:0;width:210mm;height:2000mm;border:0';
    document.body.appendChild(f);
    var d = f.contentDocument;
    /* The sheet's <img> srcs are Liquid asset_urls, so they are protocol
       relative for the same reason and would break in the iframe too. Resolve
       them on the live nodes before the markup is copied across. */
    var imgs = qdoc().querySelectorAll('img');
    for (var m = 0; m < imgs.length; m++) {
      imgs[m].setAttribute('src', absUrl(imgs[m].getAttribute('src')));
    }
    d.open();
    d.write(
      '<!doctype html><html><head><meta charset="utf-8"><title>'
      + 'Shiok BBQ Quotation ' + q.number + '</title>'
      /* font-display:block, not swap. A swap would let the page lay out in a
         fallback face and print at the wrong widths if the woff2 is a moment
         late, which on a measured document means wrong geometry. Blocking is
         the safe failure here, and fonts.ready is awaited below anyway. */
      + fontFace()
      + '<link rel="stylesheet" href=' + JSON.stringify(absUrl(cfg('css', ''))) + '>'
      + '</head><body>' + qdoc().innerHTML + '</body></html>');
    d.close();

    /* FONTS AND IMAGES BOTH, before anything reads the layout. A logo that has
       not decoded renders as a gap, and a font that has not loaded lays the
       text out at the wrong widths, which on a measured document means wrong
       geometry. Waiting costs nothing the buyer can feel. */
    var waits = [];
    try { waits.push(d.fonts.ready); } catch (e) {}
    for (var n = 0; n < d.images.length; n++) {
      var img = d.images[n];
      if (!img.complete) {
        waits.push(new Promise(function (res) {
          img.addEventListener('load', res); img.addEventListener('error', res);
        }));
      }
    }
    return Promise.all(waits).catch(function () {}).then(function () { return f; });
  }

  function binSheet(f) { try { f.remove(); } catch (e) {} }

  /* ---- the fallback: the browser's own print engine ----
     Used when the two libraries cannot be fetched, which on a storefront means
     the buyer is offline or something is blocking the CDN. A print sheet is a
     worse experience than a download but it is a far better one than a button
     that does nothing, and the file it makes is actually the crisper of the two. */
  function printDoc(q) {
    buildSheet(q).then(function (f) {
      try { f.contentWindow.focus(); f.contentWindow.print(); } catch (e) {}
      /* Removing the iframe while the dialog is open cancels the print in some
         builds, so it goes on afterprint, with a timer in case that never
         fires, which it does not on some mobile browsers. */
      var gone = false;
      function bin() { if (gone) return; gone = true; binSheet(f); }
      try { f.contentWindow.addEventListener('afterprint', bin); } catch (e) {}
      setTimeout(bin, 60000);
    });
  }

  /* ---- the real download ----
     Boss 2026-09-09, choosing a file in Downloads over a print sheet. The two
     libraries are fetched on FIRST CLICK, never on page load, so a buyer who
     never asks for the PDF never pays for 560KB of script.

     WHY html2canvas IS SAFE HERE, which was not obvious. It reimplements CSS
     painting, so the worry was the document's clip-path and its three column
     terms. Measured instead of assumed: the same sheet was rendered through
     Chromium's print pipeline and through html2canvas and compared pixel by
     pixel. Mean difference 2.4 of 255, the empty middle bands identical, the
     grid header and the three column terms both correct. What survives is
     antialiasing. The clip-path had already been replaced by a border triangle
     for a different reason, which is the one thing that would have broken.

     PNG AT SCALE 3, both measured. Scale 3 is 2382x3369 for A4, about 288dpi,
     and PNG because the terms are set at 7.2pt where JPEG ringing shows. That
     lands at roughly 380KB, near enough the print engine's own output, and a
     quotation gets emailed to a finance department so the weight matters. */
  /* V3.27 R7, THE ONE REAL DEPARTURE FROM THE THEME VERSION. There both
     libraries are fetched from cdnjs at download time. This file is sent to the
     owner and opened from wherever it lands, so it carries them inlined instead
     and this function hands the already loaded global to whichever window needs
     it rather than injecting a script tag. html2canvas still runs against the
     IFRAME's element, which is what keeps the storefront's CSS out of the
     document, and jsPDF still runs in the page, which is what owns the save. */

  function loadInto(win, which) {
    /* THEME. The draft inlines both libraries because it travels as one file.
       Here they are theme assets, fetched from the store's own origin on the
       first click and never on a page view, so a buyer who does not ask for a
       PDF never pays the 550KB. Same origin also means no ad blocker and no
       third party host, which is the whole reason decision 20 put the submit
       behind the App Proxy in the first place. */
    var need = which === 'h2c' ? 'html2canvas' : 'jspdf';
    return new Promise(function (res, rej) {
      if (window[need]) { win[need] = window[need]; res(); return; }
      var url = absUrl(cfg(which === 'h2c' ? 'h2c' : 'jspdf', ''));
      if (!url) { rej(new Error(need + ' has no url')); return; }
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () {
        if (!window[need]) { rej(new Error(need + ' did not define itself')); return; }
        win[need] = window[need];
        res();
      };
      s.onerror = function () { rej(new Error(need + ' failed to load')); };
      document.head.appendChild(s);
    });
  }

  /* ---- html2canvas puts centred text too LOW, and this is the one place it shows ----
     Boss 2026-09-12, on the generated PDF: "the text button in pdf is not
     perfect, kurang tengah center". Measured rather than guessed, and the
     measurement is what made the fix small.

     The CSS is NOT at fault. Rendered live, the pay button's line box sits
     12.89px from the top and 14.39px from the bottom of a 42.5px pill, which is
     centred. Rasterised by html2canvas the glyphs land 6.66px BELOW the pill's
     centre, which on a 42.5px control is impossible to miss.

     What it is not: not the font (Inter Tight 6.66, Arial 7.00, system-ui 6.00,
     Georgia 6.66), not the box model (align-self, table-cell, an inner span and
     a flex centre all landed within a pixel of each other), and not padding
     (raising it made the error worse, not better). It is html2canvas's own
     baseline placement, and it scales with the TYPE: 0.532 of font-size at
     9.4pt, 0.536 at 14pt, 0.571 at 7pt. So the correction is a ratio computed at
     run time, never a hardcoded pixel count that a later font-size change would
     silently invalidate.

     SCOPED TO THE RASTER PATH ONLY. This runs on the off screen iframe that
     downloadDoc() builds, so the live page and the print fallback, where the
     text is already centred, are untouched. Applying it to the stylesheet would
     fix the PDF and break both of those.

     Measured after: offset 0.00px, pill height unchanged at 42.5px, so the link
     annotation rect that downloadDoc() takes from the same element still lands
     on the button.

     STAGE 4: assets/quotation-form.js on the theme carries the same downloadDoc
     and therefore the same defect. It needs this identical function and call. */
  function nudgePayLabel(f) {
    try {
      var doc = f.contentDocument;
      var a = doc.querySelector('.pay__btn');
      if (!a || a.querySelector('.pay__fix')) return;
      var fs = parseFloat(f.contentWindow.getComputedStyle(a).fontSize) || 0;
      if (!fs) return;
      /* THEME, and the ratio is the OPPOSITE SIGN here. Boss on the real PDF:
         "tulisan button di pdf kurang turun kebawah, harus pas ditengah". The
         draft's 0.53 was measured against the draft's own raster; measured
         again on the theme's, by scanning the generated canvas rather than
         looking at it, the label landed 24 raster px (8 CSS px) ABOVE the
         pill's centre, in a pill 132 raster px tall. Numbers: pill rows
         1814 to 1945, glyph ink 1840 to 1871, 26px of air above and 74 below.
         Since the displacement is linear in the ratio and the face is 9.4pt
         (12.53px), un-nudged the label sits 1.36px high, so the ratio that
         centres it on THIS document is a small DOWNWARD shift, not an upward
         one.
         THEN MEASURED A SECOND TIME, because one point cannot fit a line. A
         downward shift of 1.35px moved the label from 8.00px above centre to
         1.83px below it, so the response is 1.23px of measured offset per 1px
         of applied shift and the displacement that lands it dead centre is
         -0.14px. In other words THIS DOCUMENT NEEDS NO COMPENSATION AT ALL:
         html2canvas is not mis-placing the label here the way it did on the
         draft, so the honest value is zero and the remaining 0.17px is below
         the noise of reading a glyph edge off a raster.
         The span stays even at zero, because it is also what carries the
         underline across: html2canvas reads text-decoration off the element
         that OWNS the text, so reparenting without re-declaring it drops the
         underline entirely. Re-measure with the canvas scan if the document's
         type ever changes. */
      var up = Math.round(fs * 0 * 100) / 100;
      var span = doc.createElement('span');
      span.className = 'pay__fix';
      /* THE UNDERLINE HAS TO RIDE ON THE SPAN, not be inherited. Moving the
         label into a child element left html2canvas drawing no underline at
         all, because it reads the decoration off the element that owns the text
         rather than walking up to the anchor. Copy the computed value across so
         the raster matches the stylesheet instead of quietly dropping it. */
      span.setAttribute('style',
        'display:block;position:relative;top:' + (up * -1) + 'px;'
        + 'text-decoration:underline;text-underline-offset:2.2px;'
        + 'text-decoration-thickness:1px;color:inherit');
      span.textContent = a.textContent.trim();
      a.textContent = '';
      a.appendChild(span);
    } catch (e) {}
  }

  /* ---- long-order pagination for the raster download path (decision 27) ----
     html2canvas rasterises the WHOLE .pg element into one tall canvas no
     matter how long the order is; it does not know about @page or
     page-break CSS at all, that machinery only exists for printDoc()'s
     native print() fallback. So a long order has to be sliced into A4-sized
     bands here, in JS, after the canvas exists, and the table's own <thead>
     redrawn at the top of every band after the first, which is the
     "repeated column header" open item 9 asked for. The footer band needs
     no special handling: there is exactly one .ft in the DOM, so wherever
     the last slice lands, that slice is by construction the only one
     carrying it, which is the "footer band only on the last page" half of
     the same item.

     cut() only ever cuts BETWEEN two <tbody> rows (or at the very end of
     the sheet), never through one, matching the CSS break-inside:avoid on
     .tb tbody tr for the print path. A row taller than a whole page cannot
     happen on this document (fixed row height, wrapped description text at
     worst two lines), but the loop still guards against an infinite loop if
     it ever did, by hard-cutting at the target instead of stalling. */
  function paginateCanvasToPdf(canvas, pg, doc) {
    /* TWO DIFFERENT SCALES, kept apart on purpose. mmPerCssPx is the sheet's
       own physical size (210mm wide, whatever that measures as in CSS px,
       the same conversion the pay-button link always used) and is what
       turns a getBoundingClientRect() into millimetres. pxPerMm is the
       CANVAS's own resolution (canvas.width already covers those same
       210mm, oversampled by whatever the html2canvas `scale` OPTION was,
       3 or the 2 fallback) and is what turns millimetres into a pixel
       offset for cropping the canvas. Conflating the two undercounts a
       page by roughly the CSS-px-per-mm constant (about 3.78x), which is
       the bug this comment exists to stop a future edit from reintroducing. */
    var pgRect = pg.getBoundingClientRect();
    var mmPerCssPx = 210 / pgRect.width;
    var pxPerMm = canvas.width / 210;
    var totalMm = canvas.height / pxPerMm;

    if (totalMm <= 297 + 0.5) {
      var png1 = canvas.toDataURL('image/png');
      doc.addImage(png1, 'PNG', 0, 0, 210, totalMm, undefined, 'FAST');
      return { pages: 1, mmPerCssPx: mmPerCssPx, pageBoundsMm: [{ startMm: 0, endMm: totalMm, headMm: 0 }] };
    }

    var theadEl = pg.querySelector('.tb thead');
    var theadRect = theadEl.getBoundingClientRect();
    var headTopMm = (theadRect.top - pgRect.top) * mmPerCssPx;
    var headMm = (theadRect.bottom - pgRect.top) * mmPerCssPx - headTopMm;

    /* Safe cut points, in the WHOLE sheet's own mm coordinate: every table
       row's bottom edge, then the boundary between each of the three tail
       blocks (totals, pay band, footer), then the sheet's true end. Boss
       2026-09-13, first real download, exactly this order's length: with
       only the row boundaries as candidates the whole 156mm tail (totals
       + pay band + footer, previously treated as ONE atomic block) missed
       page 1's last ~123mm of headroom and was pushed whole onto page 2,
       leaving both pages half empty ("dont leave too much space in page
       1"). Splitting the tail into its three natural sub-blocks (each one
       still break-inside:avoid on its own, matching the print CSS) gives
       the packer finer-grained candidates, so it fills page 1 with
       whichever of totals/pay band/footer actually fit instead of
       deferring all three over a shortfall in the smallest one. */
    var rowEls = pg.querySelectorAll('.tb tbody tr');
    var cutsMm = [];
    for (var i = 0; i < rowEls.length; i++) {
      var r = rowEls[i].getBoundingClientRect();
      cutsMm.push((r.bottom - pgRect.top) * mmPerCssPx);
    }
    /* Where the table ITSELF ends, before the totals/pay/footer tail block
       starts. A continuation page only needs the repeated <thead> when it
       actually opens with more table rows; a page that opens on the totals,
       the pay band, or the footer must not show a floating column header
       over content it does not belong to. */
    var tableEndMm = rowEls.length ? cutsMm[cutsMm.length - 1] : 0;
    ['.sums', '.strip'].forEach(function (sel) {
      var el = pg.querySelector(sel);
      if (el) cutsMm.push((el.getBoundingClientRect().bottom - pgRect.top) * mmPerCssPx);
    });
    cutsMm.push(totalMm);

    function nearestCutAtMost(targetMm) {
      var best = 0;
      for (var i = 0; i < cutsMm.length; i++) {
        if (cutsMm[i] <= targetMm + 0.1 && cutsMm[i] > best) best = cutsMm[i];
      }
      return best;
    }

    var cursorMm = 0, pageIndex = 0, pageBoundsMm = [];
    while (cursorMm < totalMm - 0.1) {
      var isFirst = pageIndex === 0;
      var headOnThisMm = (!isFirst && cursorMm < tableEndMm - 0.1) ? headMm : 0;
      var targetMm = cursorMm + (297 - headOnThisMm);
      var cutMm = targetMm >= totalMm ? totalMm : nearestCutAtMost(targetMm);
      /* Guard, not expected to fire on this document: nothing between
         cursor and target was a safe cut (a single row taller than a whole
         page), so hard-cut at the target rather than loop forever. */
      if (cutMm <= cursorMm) cutMm = Math.min(targetMm, totalMm);
      var sliceMm = cutMm - cursorMm;

      var pageCanvas = document.createElement('canvas');
      pageCanvas.width = canvas.width;
      pageCanvas.height = Math.round((headOnThisMm + sliceMm) * pxPerMm);
      var ctx = pageCanvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      if (headOnThisMm > 0) {
        /* THE REPEATED COLUMN HEADER: the same <thead> band, cropped once
           from the top of the source canvas, redrawn at the top of every
           page that opens with more table rows. A page whose remaining
           content is only the totals/pay/footer tail (headOnThisMm is 0
           there, see above) does not get one, it has no columns to head. */
        ctx.drawImage(canvas, 0, headTopMm * pxPerMm, canvas.width, headMm * pxPerMm,
                      0, 0, canvas.width, headMm * pxPerMm);
      }
      ctx.drawImage(canvas, 0, cursorMm * pxPerMm, canvas.width, sliceMm * pxPerMm,
                    0, headOnThisMm * pxPerMm, canvas.width, sliceMm * pxPerMm);

      var pagePng = pageCanvas.toDataURL('image/png');
      var mmH = pageCanvas.height / pxPerMm;
      if (pageIndex > 0) doc.addPage();
      doc.addImage(pagePng, 'PNG', 0, 0, 210, mmH, undefined, 'FAST');

      pageBoundsMm.push({ startMm: cursorMm, endMm: cutMm, headMm: headOnThisMm });
      cursorMm = cutMm;
      pageIndex++;
    }
    return { pages: pageIndex, mmPerCssPx: mmPerCssPx, pageBoundsMm: pageBoundsMm };
  }

  /* Converts one element's live rect into which PDF page it printed on plus
     its x/y/w/h in mm on THAT page, so a jsPDF link annotation lands
     correctly regardless of how many pages the sheet needed. Works in the
     same whole-sheet mm coordinate paginateCanvasToPdf cut against, so a
     page found here is the same page that element's pixels actually landed
     on in the canvas slicing above. */
  function locateOnPage(el, pg, pageInfo) {
    var pgRect = pg.getBoundingClientRect(), er = el.getBoundingClientRect();
    var mm = pageInfo.mmPerCssPx;
    var topMm = (er.top - pgRect.top) * mm;
    for (var i = 0; i < pageInfo.pageBoundsMm.length; i++) {
      var b = pageInfo.pageBoundsMm[i];
      if (topMm >= b.startMm - 0.1 && topMm < b.endMm + 0.1) {
        return {
          page: i + 1,
          xMm: (er.left - pgRect.left) * mm,
          yMm: b.headMm + (topMm - b.startMm),
          wMm: er.width * mm,
          hMm: er.height * mm
        };
      }
    }
    return null;
  }

  function downloadDoc(q) {
    var btn = document.getElementById('qwDownload');
    var note = document.getElementById('qwDlNote');
    function busy(on) {
      if (btn) { btn.disabled = on; if (on) { btn.setAttribute('data-busy','1'); }
                 else { btn.removeAttribute('data-busy'); } }
      if (note) note.textContent = on ? 'Building your PDF, one moment.' : '';
    }
    busy(true);

    var frame;
    /* html2canvas runs INSIDE the iframe, not in the page. The sheet's
       stylesheet only exists in there, so the page has no idea how to lay the
       document out, and linking it here would repaint the storefront. jsPDF
       runs in the page, because it is the page that owns the download. */
    return buildSheet(q).then(function (f) {
      frame = f;
      nudgePayLabel(f);
      return Promise.all([
        loadInto(f.contentWindow, 'h2c'),
        loadInto(window, 'jspdf')
      ]);
    }).then(function () {
      var w = frame.contentWindow, d = frame.contentDocument;
      var pg = d.querySelector('.pg');
      /* Scale 3 first. A weak phone can refuse a canvas that large, and the
         honest response to that is a slightly softer file rather than none, so
         it falls back to 2 rather than failing. */
      function shoot(scale) {
        return w.html2canvas(pg, { scale: scale, backgroundColor: '#ffffff',
                                   useCORS: true, logging: false });
      }
      return shoot(3).catch(function () { return shoot(2); }).then(function (canvas) {
        var jsPDF = (window.jspdf || {}).jsPDF;
        if (!jsPDF) throw new Error('jsPDF missing');
        var doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true });
        var pageInfo = paginateCanvasToPdf(canvas, pg, doc);
        if (window.console && console.log) {
          console.log('[quotation pdf] pages:', pageInfo.pages,
            'sheet height mm:', Math.round(canvas.height / (canvas.width / 210)),
            'page bounds mm:', JSON.stringify(pageInfo.pageBoundsMm));
        }

        /* THE PAY BUTTON MUST STAY CLICKABLE. Rasterising the page turns it
           into pixels, and a quotation whose only call to action is dead is
           worse than no button. jsPDF can lay a link annotation over the image,
           so the rect is measured off the real element and converted from px to
           mm against the sheet's known 210mm width, on whichever page the pay
           band actually landed on for this order's length. */
        try {
          var a = d.querySelector('.pay__btn');
          if (a && a.getAttribute('href')) {
            var loc = locateOnPage(a, pg, pageInfo);
            if (loc) {
              /* V3.29 R11, Boss 2026-09-14, "i can't click the button?".
                 ALWAYS setPage, never `if (loc.page > 1)`. jsPDF adds an
                 annotation to the CURRENT page, and the pagination loop above
                 leaves the cursor on the LAST page, so on a two page quotation
                 a button printing on page 1 had its link written onto page 2.
                 Measured on his own download: one /Annots, one /URI, and it
                 sat on page object 5 (page 2) while the pixels were on page
                 object 3. The rect itself was always correct, x 49.7mm,
                 width 66.7mm, 226.4 to 238.1mm down, which is why a one page
                 quotation was clickable all along and only long orders broke.
                 Nothing to do with the URL's length. */
              doc.setPage(loc.page);
              doc.link(loc.xMm, loc.yMm, loc.wMm, loc.hMm, { url: a.href });
            }
          }
        } catch (e) {}

        doc.save('Shiok BBQ Quotation ' + q.number + '.pdf');
        binSheet(frame);
        busy(false);
        if (note) note.textContent = 'Saved to your downloads.';
      });
    }).catch(function () {
      /* Anything at all went wrong, most likely the CDN. Fall back to the
         print engine rather than leaving the buyer with nothing. */
      binSheet(frame);
      busy(false);
      if (note) note.textContent = 'Opening your print sheet instead. Choose "Save as PDF".';
      printDoc(q);
    });
  }

  /* The button is wired once, at start up, not inside submit(), because
     submit() can run more than once: a buyer who edits from the review step
     and comes back arrives here again, and a listener added per submit would
     fire twice and open two print dialogs. */
  (function () {
    var btn = document.getElementById('qwDownload');
    if (!btn) return;
    btn.addEventListener('click', function () {
      if (btn.disabled || !QUOTE) return;
      downloadDoc(QUOTE);
    });
  })();

  /* ====================================================================
     SUBMIT, V3.27 R7
     ....................................................................
     The one page form has no steps to hide, so this is simpler than the
     wizard's submit(): it hides the intro, the basket strip and the form,
     shows the thank you block, and starts the delivery lookup immediately
     so the figure has landed by the time the buyer has read the screen.
     ==================================================================== */
  /* ====================================================================
     SUBMIT, RESUME, AND THE HEADER
     ....................................................................
     THEME. Everything below replaces the draft's own submitQuote(), which
     priced the order in the browser because there was no backend to ask.
     ==================================================================== */

  function cfgFlag(name){ return cfg(name, '0') === '1'; }

  function showError(branchIsService, message){
    var box  = $(branchIsService ? '#q1ServiceError' : '#q1DeliveryError');
    var body = $(branchIsService ? '#q1ServiceErrorBody' : '#q1DeliveryErrorBody');
    if (!box || !body) return;
    var wa = cfg('wa', ''), mail = cfg('mail', '');
    body.textContent = message || T('err_generic','Something went wrong on our side.');
    if (wa || mail) {
      body.appendChild(document.createElement('br'));
      var span = document.createElement('span');
      span.textContent = T('err_reach','You can still reach us');
      body.appendChild(span);
      if (wa) {
        body.appendChild(document.createTextNode(T('err_on',' on ')));
        var a = document.createElement('a');
        a.href = wa; a.textContent = 'WhatsApp'; a.target = '_blank'; a.rel = 'noopener';
        body.appendChild(a);
      }
      if (mail) {
        body.appendChild(document.createTextNode(wa ? T('err_or_at',' or at ') : T('err_at',' at ')));
        var m = document.createElement('a');
        m.href = 'mailto:' + mail; m.textContent = mail;
        body.appendChild(m);
      }
      body.appendChild(document.createTextNode(T('err_end','.')));
    }
    box.hidden = false;
  }

  function clearError(branchIsService){
    var box = $(branchIsService ? '#q1ServiceError' : '#q1DeliveryError');
    if (box) box.hidden = true;
  }

  /* The payload of section 6.1. lines carries variant and quantity because that
     is what Shopify needs to price the order, and the prices ride along only so
     a failed run can be read back later. Nothing here is trusted for money. */
  function buildPayload(){
    var service = isServiceQuote();
    var surcharge = computeSurcharge();
    var extras = EXTRAS.map(function (x) { return { title: x.title, price: x.price, quantity: extraQty(x) }; });
    /* The surcharge travels as an extra so Shopify charges it as a real line,
       which is exactly how the review step already presents it. */
    if (surcharge) extras.push({ title: surcharge.label, price: surcharge.total });
    var body = {
      submittedAt: Date.now(),
      trap: (document.getElementById('q1Trap') || {}).value || '',
      quoteType: selected('quote_type'),
      cart: {
        token: CART_TOKEN,
        currency: 'SGD',
        itemCount: totalUnits(),
        lines: CART.map(function (l) {
          var line = { variantId: l.variant_id || null, quantity: l.quantity,
                       title: l.title, variantTitle: l.variant_title || '',
                       price: l.final_price };
          /* V3.34: Globo lines only. Every other line is byte for byte the old
             shape, so its fingerprint and its draft order do not change. */
          var gp = gpoPayload(l);
          if (gp) line.properties = gp;
          return line;
        }),
        extras: extras
      },
      event: service ? {
        date: v('#q1Date'), eventStart: v('#q1EventStart'), eventEnd: v('#q1EventEnd'),
        mealTime: v('#q1Meal'), venue: v('#q1Venue'), postalCode: v('#q1Postal'),
        venueType: selected('venue_type') === 'Other' ? v('#q1VenueOther') : selected('venue_type'),
        guests: parseInt(v('#q1Pax'), 10) || 0,
        hasGrill: selected('has_grill'), grillType: v('#q1GrillTypeMobile') || selected('grill_type'),
        shelter: selected('shelter'), dining: selected('dining')
      } : {
        deliveryDate: v('#q1DeliveryDate'),
        deliverySlotId: v('#q1DeliverySlot'),
        deliverySlot: selectedText('#q1DeliverySlot'),
        venue: v('#q1DeliveryAddress'), postalCode: v('#q1DeliveryPostal')
      },
      contact: {
        name: val('qwName'), phone: val('qwPhone'), email: val('qwEmail')
      },
      company: { name: val('qwCo'), address: val('qwCoAddr'), uen: val('qwUen') },
      message: val('qwMsg'),
      termsAccepted: true
    };
    return body;
  }

  var SENDING = false;
  var CART_TOKEN = '';

  function submitQuote(branchIsService, button){
    /* LAYER ONE OF THREE against one event becoming two draft orders
       (decision 51), and the only layer that can catch a double click. n8n
       persists its own memory when a run ENDS, so two runs a third of a second
       apart never see each other, and Shopify's search index lags a few seconds
       behind the tag the third layer looks for. Both measured, 2026-09-14. */
    if (SENDING) return;
    SENDING = true;
    clearError(branchIsService);
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = T('sending','Sending…'); }

    fetch(cfg('submit', '/apps/quotation/submit'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(buildPayload())
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.body || res.body.ok !== true) {
          throw new Error((res.body && res.body.message) || T('err_raise','We could not raise your quotation.'));
        }
        showDone(res.body);
      })
      .catch(function (err) {
        /* The lock releases on failure and ONLY on failure. A buyer whose first
           attempt died must be able to try again; a buyer whose first attempt
           worked must not be able to send a second. */
        SENDING = false;
        if (button) { button.disabled = false; button.textContent = label || T('get_pdf','Get Quotation PDF'); }
        showError(branchIsService, err && err.message);
      });
  }

  /* The thank you state, reached from a submission and from a resume link
     alike. It reads only the payload, so the two paths cannot drift. */
  function showDone(p){
    var form = $('#q1Form'), done = $('#q1Done'), intro = document.querySelector('.q1__intro'),
        basket = $('#qwBasket');
    if (form) form.style.display = 'none';
    if (intro) intro.style.display = 'none';
    if (basket) basket.style.display = 'none';
    if (done) { done.classList.add('is-on'); done.scrollIntoView({ block: 'start' }); }

    var btn = $('#qwDownload'), numEl = $('#qwDoneNum'),
        totEl = $('#qwDoneTotal'), brkEl = $('#qwDoneBreak');

    QUOTE = buildQuote(p);
    if (numEl) numEl.textContent = T('done_quote','Quotation ') + (p.quotationNumber || '')
      + (QUOTE.valid ? T('done_valid',' · valid until ') + QUOTE.valid : '');
    if (totEl) totEl.textContent = money(QUOTE.total);
    if (brkEl) brkEl.textContent = QUOTE.delivery
      ? TF('done_incl_delivery','Includes {delivery} and 9% GST',{delivery:QUOTE.delivery.name.toLowerCase()})
      : T('done_incl','Includes 9% GST');

    if (!qdoc()) { if (btn) btn.hidden = true; return; }
    fillDoc(QUOTE);
    if (btn) { btn.disabled = false; btn.removeAttribute('data-busy'); }
  }

  /* ---- the resume link ----
     decision 47. The page is opened at ?q=<number>&k=<key>, and the two values
     travel to n8n in a POST body rather than on the URL it forwards, so the key
     never lands in a Referer header or a proxy log. n8n reads the draft order
     and returns the same payload a submission returns, which is what lets this
     redraw the identical document without creating anything. */
  function resumeParams(){
    var p = new URLSearchParams(window.location.search);
    var q = (p.get('q') || '').trim(), k = (p.get('k') || '').trim();
    return (q && k) ? { q: q, k: k } : null;
  }

  function runResume(r){
    var form = $('#q1Form'), intro = document.querySelector('.q1__intro'),
        basket = $('#qwBasket'), done = $('#q1Done');
    if (form) form.style.display = 'none';
    if (intro) intro.style.display = 'none';
    if (basket) basket.style.display = 'none';
    if (done) done.classList.add('is-on');
    var btn = $('#qwDownload'), numEl = $('#qwDoneNum'),
        totEl = $('#qwDoneTotal'), brkEl = $('#qwDoneBreak');
    if (btn) { btn.disabled = true; btn.setAttribute('data-busy', '1'); }
    if (numEl) numEl.textContent = T('opening','Opening your quotation…');
    if (totEl) totEl.textContent = '—';
    if (brkEl) brkEl.textContent = '';

    fetch(cfg('fetch', '/apps/quotation/fetch'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(r)
    })
      .then(function (res) { return res.json(); })
      .then(function (body) {
        if (!body || body.ok !== true) {
          throw new Error((body && body.message) || T('link_invalid','This quotation link is no longer valid.'));
        }
        showDone(body);
      })
      .catch(function (err) {
        var h = done ? done.querySelector('.qw__q') : null;
        if (h) h.textContent = T('cant_open','We could not open this quotation');
        if (numEl) numEl.textContent = err && err.message;
        if (totEl) totEl.textContent = '';
        if (brkEl) brkEl.textContent = '';
        if (btn) { btn.hidden = true; }
      });
  }

  /* ---- the header, on this page only ----
     Boss 2026-09-14. The store's own drawer carries View cart and Check Out,
     either of which throws away a part filled form, and it can only draw
     cart.items, so it would show a smaller basket than this page whenever a
     Dedicated Server or a surcharge is on the quotation. So the cart icon opens
     THIS page's drawer and the pill reads THIS page's figures.

     Bound in the capture phase on the document, which is what lets it win
     against the header section's own listener without that file being touched.
     This script exists only on this page, so it cannot reach any other. */
  function takeOverHeaderCart(){
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-shiok-cart]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      e.stopPropagation();
      openCart(a);
    }, true);
  }

  function paintHeaderPill(units, subtotalCents){
    /* Lesson from 2026-09-12, caught by Boss on his own phone: a lifted header
       kept its own numbers and contradicted the page it sat on. Every figure a
       page shows must come from the same place. */
    var totals = document.querySelectorAll('[data-header-cart-total]');
    var counts = document.querySelectorAll('[data-header-cart-count]');
    var i;
    for (i = 0; i < totals.length; i++) totals[i].textContent = money(subtotalCents);
    for (i = 0; i < counts.length; i++) counts[i].textContent = String(units);
  }

  /* ---- the UEN field tidies itself ----
     Boss 2026-09-14, after the backend stopped validating UEN entirely. The
     point is a CLEAN value, not a narrow one: spaces and hyphens are dropped and
     letters are upper cased as the buyer types, so "t08-ll-1234 a" becomes
     "T08LL1234A" on its own.

     LETTERS STAY ALLOWED, on purpose, and this is the one thing not to "tidy"
     further. Every published UEN shape ends in a check letter and one of them
     opens with T, S or R (nnnnnnnnX, yyyynnnnnX, TyyPQnnnnX), so a digits only
     field would make it impossible to enter a single valid UEN, which is the
     same door the backend rule was just taken off.

     No maxlength either. Stripping junk is reversible for the buyer, silently
     truncating what they typed is not, and nothing downstream computes with
     this value anyway. */
  function tidyUen(el){
    var before = el.value;
    var pos = el.selectionStart == null ? before.length : el.selectionStart;
    var removedBefore = (before.slice(0, pos).match(/[^A-Za-z0-9]/g) || []).length;
    var clean = before.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (clean === before) return;
    el.value = clean;
    /* Put the caret back where the buyer left it, minus whatever was dropped in
       front of it. Without this, correcting a character in the middle throws the
       caret to the end on every keystroke. */
    var np = Math.max(0, pos - removedBefore);
    try { el.setSelectionRange(np, np); } catch (e) {}
  }

  function wireUenFields(){
    ['#q1Uen', '#q1DeliveryUen'].forEach(function (sel) {
      var el = $(sel);
      if (!el) return;
      el.setAttribute('autocapitalize', 'characters');
      el.setAttribute('autocorrect', 'off');
      el.setAttribute('spellcheck', 'false');
      el.addEventListener('input', function () { tidyUen(el); });
      el.addEventListener('blur', function () { tidyUen(el); });
    });
  }

  function bootstrap(){
    wireUenFields();
    takeOverHeaderCart();
    seedCart();
    var r = resumeParams();
    if (r) { runResume(r); return; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (c) { if (c) { CART_TOKEN = c.token || ''; adoptCart(c); } })
      .catch(function () {});
  }

  updateLogic();
  bootstrap();
})();

